var contentSlider = {
    init: function() {
        var self = this;

        $( '[data-content-slider]' ).each( function() {
            var $slider = $( this );

            $slider.on('init', function(event, slick) {
                var nextTitle = $( slick.$slides[1] ).attr( 'data-content-slider-title' );

                $slider.find( '[data-content-slider-label="prev"]' ).html( '' );
                $slider.find( '[data-content-slider-label="next"]' ).html( nextTitle );
            } );

            $slider.on('reInit', function(event, slick) {
                var nextTitle = $( slick.$slides[1] ).attr( 'data-content-slider-title' );

                $slider.find( '[data-content-slider-label="prev"]' ).html( '' );
                $slider.find( '[data-content-slider-label="next"]' ).html( nextTitle );
            } );

            $slider.slick( {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                mobileFirst: true,
                arrows: true,
                prevArrow: '<span><i class="icon-arrow-reverse"></i> <span data-content-slider-label="prev"></span></span>',
                nextArrow: '<span><span data-content-slider-label="next"></span> <i class="icon-arrow"></i></span>',
                rows: 0,
                centerMode: false,
                variableWidth: false,
                outerEdgeLimit: true,
                adaptiveHeight: true,
                responsive: [
                ]
            } );

            $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {


                var currentTitle = $( slick.$slides[currentSlide] ).attr( 'data-content-slider-title' );
                var nextTitle = $( slick.$slides[nextSlide] ).attr( 'data-content-slider-title' );

                $slider.find( '.slick-arrow' ).addClass( 'hidden' );

                if ( currentSlide < nextSlide ) {
                    $slider.find( '[data-content-slider-label="prev"]' ).html( currentTitle );
                    $slider.find( '[data-content-slider-label="next"]' ).html( $( slick.$slides[nextSlide + 1] ).attr( 'data-content-slider-title' ) );
                } else {
                    $slider.find( '[data-content-slider-label="next"]' ).html( currentTitle );
                    $slider.find( '[data-content-slider-label="prev"]' ).html( $( slick.$slides[nextSlide - 1] ).attr( 'data-content-slider-title' ) );
                }
            } );

            $slider.on('afterChange', function(event, slick, currentSlide, nextSlide) {
                $( '.slick-arrow' ).removeClass( 'hidden' );
            } );

            $(document.body).on( 'webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange', function() {
                $slider.slick("setOption", 'centerMode', false, true);
                $(window).trigger( 'resize' );
            } );
        } );
    },
}

export {
    contentSlider
};
